import React, {useState} from 'react';
import CategoriesContext from './CategoriesContext';

const CategoriesProvider = ({children}) => {
    const [selectedColumn, setSelectedColumn] = useState(null);
    const [searchedTerm, setSearchedTerm] = useState(null);
    return (
        <CategoriesContext.Provider
            value={{
                column: [selectedColumn,
                    setSelectedColumn],
                search: [searchedTerm, setSearchedTerm],
            }}
        >{children}
        </CategoriesContext.Provider>
    );
};


export default CategoriesProvider;
